module.exports = __webpack_public_path__ + "img/744.64c2a75d.jpg";